import React from 'react';

import Image from '../../library/image/image';
import Link from '../../library/link/link';
import Typography from '../../library/typography/typography';
import PhoneNumber from '../phone-number/phone-number';

import { getStoreFeaturedServices } from '../../shared/utils/store/store';
import { isArrayWithLength } from '../../shared/utils/validators/validators';

import { Maybe, StoreData } from '../../shared/types/graphql-types';
import { SERVICE_CODE } from '../../shared/constants/store';

import './store-featured-services.scss';

export const FEATURED_SERVICES = {
  [SERVICE_CODE.MOBILE_INSTALLATION]: {
    altText: `A gray mobile installation van with ${window.siteName} displayed on the side`,
    linkDescription: 'is available for an additional fee!',
    linkText: 'Mobile installation',
    src: 'https://discounttire.scene7.com/is/image/discounttire/mobileInstallation_hero_dt'
  },
  [SERVICE_CODE.WHEEL_ALIGNMENT]: {
    altText: `A close up of ${window.siteName}'s alignment system attached to tires on a vehicle`,
    linkDescription: 'are available!',
    linkText: 'Alignment services',
    src: 'https://discounttire.scene7.com/is/image/discounttire/Hero_Category_Alignment_001?cropN=.25,0,.75,1'
  }
};

interface StoreFeaturedServicesProps {
  className?: string;
  myStore: Maybe<StoreData>;
  onServiceLinkClick?: () => void;
  showLinks?: boolean;
}

function StoreFeaturedServices(props: StoreFeaturedServicesProps) {
  const {
    className = '',
    myStore,
    onServiceLinkClick,
    showLinks = false
  } = props;
  const { address } = myStore || {};
  const filteredServices = getStoreFeaturedServices(myStore);

  if (!isArrayWithLength(filteredServices)) {
    return null;
  }

  return (
    <div className={`${className} store-featured-services`}>
      {filteredServices?.map((service, index) => {
        const serviceCode = service!.code as string;

        return (
          <div
            className="store-featured-services__service-item"
            key={index}
            styleName="service-item"
          >
            <div styleName="image-container">
              <Image
                alt={FEATURED_SERVICES[serviceCode].altText}
                loading="lazy"
                src={FEATURED_SERVICES[serviceCode].src}
                styleName="icon"
              />
            </div>
            <Typography weight="heavy">
              {showLinks && service?.link ? (
                <Link onClick={onServiceLinkClick} to={service.link}>
                  {FEATURED_SERVICES[serviceCode].linkText}
                </Link>
              ) : (
                <>{FEATURED_SERVICES[serviceCode].linkText}</>
              )}{' '}
              {FEATURED_SERVICES[serviceCode].linkDescription}
            </Typography>
          </div>
        );
      })}
      <Typography styleName="phone">
        Please{' '}
        <strong>
          call the store at <PhoneNumber phone={address?.phone} />
        </strong>{' '}
        after placing your order to schedule.
      </Typography>
    </div>
  );
}

export default StoreFeaturedServices;
